<template>
    <div>
        <template v-if="dashboard === true && data !== null">
            <div>
                <div class="row">
                    <div class="col-md-12 dashboard-left">
                        <div class="row top-widgets-row">
                            <div class="col-md-3 widgets-col" v-if="identifier_system == 'FINPAY'">
                                <div class="payroll-counter-box collections-counter-box">
                                    <div class="top-box align-center total-students no-bg">
                                        <img class="mb-3" src="/images/collections-dashboard-icon1.png" />
                                        <span class="title" title="total_students"> {{total_students}} </span>
                                        <p> Total Students </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 widgets-col">
                                <div class="payroll-counter-box collections-counter-box">
                                    <div class="top-box align-center no-bg">
                                        <img class="mb-3" src="/images/collections-dashboard-icon2.png" />
                                        <span class="title" title="total_vouchers"> {{total_vouchers}} </span>
                                        <p> Total Grenerated Vouchers </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 widgets-col">
                                <div class="payroll-counter-box collections-counter-box">
                                    <div class="top-box align-center no-bg">
                                        <img class="mb-3" src="/images/collections-dashboard-icon3.png" />
                                        <span class="title" title="total_volume"> {{total_volume}} </span>
                                        <p> Total Volume </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 widgets-col">
                                <div class="payroll-counter-box collections-counter-box">
                                    <div class="top-box align-center total-amount-due no-bg">
                                        <img class="mb-3" src="/images/collections-dashboard-icon4.png" />
                                        <span class="title" title="total_amount"> {{total_amount}} </span>
                                        <p> Total Amount Paid </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col charts" v-if="identifier_system == 'FINPAY'">
                                <div class="charts-holder">
                                    <div class="chart-head mb-0">
                                        <h2> Branch Stats </h2>
                                    </div>
                                    <div class="chart-inner payrol-chart">
                                        <div id="container" class="chart"></div>
                                    </div>
                                    <div class="chart-head pt-5 pb-5">
                                        <h2> Amount Stats </h2>
                                    </div>
                                    <div class="chart-inner">
                                        <div id="amount-stats" class="chart" ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="dashboard === null && data === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="dashboard === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                dashboard : null,
                total_students : 0,
                total_vouchers : 0,
                total_volume : 0,
                total_amount : 0,
                identifier_system : null,
                amount_stats : null,
                campuses : null,
                data : null,
            };
        },
        mounted() {
            this.$Progress.start();
            var that = this;
            // Calling For Dashboard Data
            axios.get('/api/feeCompanyDashboardData')
            .then(res => {
                if(res.status == 200){
                    if(res.data.pageView == true){
                        this.dashboard = res.data.pageView;
                        this.total_students = res.data.total_students;
                        this.total_vouchers = res.data.total_vouchers;
                        this.total_volume = res.data.total_volume;
                        this.total_amount = res.data.total_amount;
                        this.identifier_system = res.data.identifier_system;
                        if(this.identifier_system == 'FINPAY'){
                            this.amount_stats = res.data.amount_stats;
                            this.campuses = res.data.campuses;
                        }
                        this.data = res.data;
                    }else{
                        this.dashboard = false;
                    }
                    this.$Progress.finish();
                }
            })
            .then(resu => {
                if(this.identifier_system == 'FINPAY'){
                    Highcharts.chart('container', {
                        chart: {
                            type: 'column',
                            style: {
                                fontFamily: 'Raleway',
                                borderWidth: 0,
                                align: 'right',
                            }
                        },
                        navigation: {
                            buttonOptions: {
                                verticalAlign: 'top',
                                y: -45
                            },
                        },
                        legend:{
                            useHTML: true,
                            itemWidth: 140,
                            verticalAlign: 'top',
                            align:'right',
                            y: 0,
                        },
                        credits: false,
                        title: {
                            text: null
                        },
                        xAxis: {
                            categories: that.campuses.map(function(value,index){
                                return value.name;
                            }),
                            style: {
                                fontFamily: 'Raleway',
                            }
                        },
                        yAxis: {
                            min: 0,
                            style: {
                                fontFamily: 'Raleway'
                            },
                            title: {
                                text: null
                            }
                        },
                        tooltip: {
                            pointFormat: '<span> <b>Rs. {point.percentage:.0f}</span></b> {series.name}<br/>',
                            shared: true,
                            useHTML: true,
                            backgroundColor: '#fff',
                            borderColor: '#e0e6e0',
                            borderRadius: 10,
                            borderWidth: 2,
                            shadow: false,
                            headerFormat: '',
                            
                        },
                        plotOptions: {
                            column: {
                                stacking: 'normal'
                            }
                        },
                        series: [{
                            showInLegend: true,
                            name: 'Total Students',
                            data: that.campuses.map(function(value,index){
                                return value.totalStudent;
                            }),
                            color: '#eef0f4',
                            borderColor: 'black',
                            borderWidth: 0,
                            style: {
                                fontFamily: 'Raleway'
                            }
                        }, {
                            showInLegend: true,
                            name: 'Amount Collected',
                            data: that.campuses.map(function(value,index){
                                return value.totallAmount;
                            }),
                            color: '#ea401f',
                            borderWidth: 0,
                        }]
                    });
                    Highcharts.chart('amount-stats', {
                        chart: {
                            type: 'column',
                            style: {
                                fontFamily: 'Raleway',
                                borderWidth: 0,
                                align: 'right',
                            }
                        },
                        exporting:{
                            enabled:false,
                        },
                        legend:{
                            enabled:false,
                            verticalAlign: 'top',
                            align:'right',
                            y: -13,
                            x: -15,
                            itemMarginTop: 10,
                            itemMarginBottom: 10,
                            itemMarginLeft: 0,
                            itemMarginRight: 0,

                        },
                        navigation: {
                            buttonOptions: {
                                verticalAlign: 'top',
                                y: 0
                            },
                        },
                        credits: false,
                        title: {
                            text: null,
                            align: 'left',
                            x: 0,
                            y: 17,
                        },
                        xAxis: {
                            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                            
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: null
                            }
                        },
                        tooltip: {
                            pointFormat: '<span style="color:#282828;"> <b>Rs. {point.percentage:.0f}</span></b> {series.name}<br/>',
                            backgroundColor: '#fff',
                            borderColor: '#e0e6e0',
                            borderRadius: 8,
                            borderWidth: 1,
                            shadow: false,
                            headerFormat: '',
                            style: {
                                opacity: 1
                            }
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0,
                                borderWidth: 0
                            }
                        },
                        series: [{
                            name: 'Students',
                            data: that.amount_stats.map(function(value,index){
                                return value.students;
                            }),
                            color: '#eef0f4',
                            borderColor: 'black',
                            borderWidth: 0,
                            style: {
                                fontFamily: 'Raleway'
                            }
                        }, {
                            name: 'Amount',
                            data: that.amount_stats.map(function(value,index){
                                return value.amount;
                            }),
                            color: '#ea401f',
                            borderWidth: 0,
                        }]
                    });
                }
            })
            .catch(err => {
                console.log(err);
                this.showAlertBox('error','Error to load data');
                this.$Progress.finish();
            });
        },
        methods: {
        }
    }
</script>
